export default "https://cdn.questicon.mathletics.com/assets/images/summary-tick-0f95320fd2a0823344ce46dc9475aba3.svg";